/** Ziel-Route einer Benachrichtigung – nutzt `link`, sonst Fallback über Typ/Metadaten, damit jeder Klick irgendwo hinführt. */
export const notificationTarget = (n) => {
  if (!n) return '/portal/benachrichtigungen';
  if (n.link) return n.link;
  const meta = n.metadata || {};
  const type = n.type || n.notification_type || '';
  const title = n.title || '';
  if (type === 'email_unzugeordnet' || /E-Mail ohne Vorgang/i.test(title)) return '/portal/admin/portal-posteingang';
  const ticketId = meta.ticket_id || (type === 'ticket' && n.related_id) || (meta.assignment_type === 'ticket' && meta.item_id);
  if (ticketId) return `/portal/vorgaenge?ticket=${ticketId}`;
  if (meta.antrag_id) return `/portal/admin/versammlungsantraege?antrag=${meta.antrag_id}`;
  if (meta.announcement_id) return '/portal/mitteilungen';
  if (meta.property_id && meta.source) return '/portal/dokumente';
  if (/Casavi/i.test(title)) return '/portal/admin/schnittstellen';
  if (/Schlüsselbestellung/i.test(title)) return '/portal/admin/schluesselbestellungen';
  return `/portal/benachrichtigungen?focus=${n.id}`;
};
